import { $FixMe } from '@eventbrite/ts-utils';
import FocusTrap from 'focus-trap-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { openCloseAnimatedDrawer as openCloseAnimatedDrawerAction } from '../../../../redux/actions/ui';
import './AnimatedDrawer.scss';

interface AnimatedDrawerProps {
    openCloseAnimatedDrawer: Function;
    rootId?: string;
}

interface AnimatedDrawerState {
    isMounted: boolean;
}

//TODO Refactor this to split component from handler declaration (container / component split)
export class AnimatedDrawer extends React.Component<
    AnimatedDrawerProps,
    AnimatedDrawerState
> {
    state = {
        isMounted: false,
    };
    filterPanelMobileMount!: Element;

    componentDidMount() {
        const appRoot = document.getElementById(this.props.rootId || 'root');

        this.filterPanelMobileMount = document.createElement('div');
        appRoot?.appendChild(this.filterPanelMobileMount);

        this.setState({ isMounted: true });

        // This command will scroll up the animated-drawer--wrapper div
        // before the slide up animation triggers
        setTimeout(() => {
            requestAnimationFrame(() => {
                window.scrollTo(0, 0);
            });
        }, 0);
    }

    componentWillUnmount() {
        this.filterPanelMobileMount?.parentNode?.removeChild(
            this.filterPanelMobileMount,
        );
    }

    render() {
        if (this.state.isMounted) {
            const { openCloseAnimatedDrawer } = this.props;

            return ReactDOM.createPortal(
                <div className="animated-drawer--wrapper">
                    <FocusTrap>
                        <div className="feed-search-page feed-search-page--mobile">
                            <div className="animated-drawer__container">
                                {/* Since this mask is meant for mouse users to click to quickly escape, */}
                                {/* and since we already have a keyboard-tabbable element for closing the modal, */}
                                {/* we don't need to follow these lint rules */}
                                {/* eslint-disable jsx-a11y/click-events-have-key-events */}
                                {/* eslint-disable jsx-a11y/no-static-element-interactions */}
                                <div
                                    className="animated-drawer__container--mask"
                                    onClick={() =>
                                        openCloseAnimatedDrawer(false)
                                    }
                                />
                                {this.props.children}
                            </div>
                        </div>
                    </FocusTrap>
                </div>,
                this.filterPanelMobileMount,
            );
        }

        return null;
    }
}

const _mapDispatchToProps = (dispatch: Function) => ({
    openCloseAnimatedDrawer: (...args: [$FixMe]) =>
        dispatch(openCloseAnimatedDrawerAction(...args)),
});

export default connect(undefined, _mapDispatchToProps)(AnimatedDrawer);
